import { styled } from "@mui/material/styles";
import { FormControl, Typography, TextField } from "@mui/material";

const INPUT_FORWARD_PROPS = [
  "$mT",
  "$mB",
  "$width",
  "$bR",
  "$color",
  "$iconColor",
];

export const StyledFormControl = styled(FormControl, {
  shouldForwardProp: (prop) => !INPUT_FORWARD_PROPS.includes(prop),
})(({ $mT, $mB }) => ({
  marginTop: $mT ?? 0,
  marginBottom: $mB ?? 2,
}));

export const StyledFormControlTextArea = styled(FormControl, {
  shouldForwardProp: (prop) => !INPUT_FORWARD_PROPS.includes(prop),
})(({ $mT, $mB }) => ({
  marginTop: $mT ? 2 : 0,
  marginBottom: $mB ?? 2,
}));

export const StyledLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "color",
})(({ color, theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "1rem",
  color: color || "#33261D",
  fontWeight: 600,
  marginBottom: 8,
  letterSpacing: "0.5px",
  minHeight: 24,
  alignContent: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "12px",
  },
}));

export const StyledLabel2 = styled(Typography)({
  color: "#666",
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 400,
  marginBottom: 16,
});

export const StyledRequiredMark = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: theme.spacing(2),
  color: "red",
  fontWeight: 600,
}));

const BaseInput = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff",
    fontFamily: "'Quicksand', sans-serif",
    fontSize: theme.spacing(2),
    fontWeight: 400,
    boxShadow:
      "-4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid rgba(73,42,24, 0.2)",
    },
    "& .MuiOutlinedInput-input": {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px transparent inset",
        transition: "background-color 5000s ease-in-out 0s",
      },
      "&:-webkit-autofill:hover": {
        WebkitBoxShadow: "0 0 0 100px transparent inset",
      },
      "&:-webkit-autofill:focus": {
        WebkitBoxShadow: "0 0 0 100px transparent inset",
      },
      "&:-webkit-autofill:active": {
        WebkitBoxShadow: "0 0 0 100px transparent inset",
      },
    },
  },
}));

export const StyledInput = styled(BaseInput, {
  shouldForwardProp: (prop) =>
    !["$width", "$bR", "$color", "$iconColor"].includes(prop),
})(({ theme, $width, $bR, $color }) => ({
  borderRadius: theme.spacing(2),
  "& .MuiOutlinedInput-root": {
    borderRadius: $bR || theme.spacing(2),
    width: $width || "75%",
    height: "55px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: $bR || theme.spacing(2),
    },
    "& .MuiOutlinedInput-input": {
      color: $color || "#33261D",
      "&::placeholder": {
        fontSize: theme.spacing(2),
        opacity: 0.5,
        [theme.breakpoints.down("sm")]: {
          fontSize: "14px",
        },
      },
    },
  },
}));

export const StyledPasswordInput = styled(BaseInput, {
  shouldForwardProp: (prop) => prop !== "$width",
})(({ $width, theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.spacing(2),
    width: $width || "75%",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: theme.spacing(2),
    },
  },
}));

export const StyledTextAreaInput = styled(BaseInput, {
  shouldForwardProp: (prop) => prop !== "$width",
})(({ $width, theme }) => ({
  "& .MuiOutlinedInput-root": {
    color: "#33261D",
    borderRadius: theme.spacing(2),
    width: $width || "75%",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: theme.spacing(2),
    },
  },
  "& .MuiOutlinedInput-input": {
    "&::placeholder": {
      fontSize: theme.spacing(2),
      opacity: 0.5,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
      },
    },
  },
}));

export const inputAdornmentSx = { paddingRight: "5px" };
export const iconSx = (iconColor) => ({
  color: iconColor || "#29405A",
  fontSize: "20px",
});
